import { useEffect, useState } from "react";
import "./contact.css"

export default function Contact(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

// Form
    const [enqData, setEnqData] = useState({
        name:"",
        mobile:"",
        mail:""
    })
    const onChangeInput = (e) =>{
        const {name, value} = e.target;
        setEnqData((preData)=>({
            ...preData,
            [name]:value
        }))
    } 
    const onSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        formData.append("access_key", process.env.REACT_APP_FORM_KEY);

        const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
        });

        const data = await response.json();
        // console.log(data)
        if (data.success) {
            alert("Thank you Our Team Will Contact You Soon...");
            event.target.reset();
            setEnqData({
                name:"",
                mobile:"",
                mail:""
            })
        } else {
            //   console.log("Error", data);
            alert("Something Went Wrong. Feel Free To Call Us...")
            setEnqData({
                name:"",
                mobile:"",
                mail:""
            })
        }
    };

    return(
        <>
        <section className="wrapper container contact">
            <p className="subTitle">Contact us</p>
            <h2>Travel&nbsp;Wise: Explore the World, Fulfill Your Dreams</h2>
            <main className="line">
                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Phone</p>
                        <a className="detail" href="tel:7357356060">735 735 6060</a>
                        <a className="detail" href="tel:9994377761">999 437 7761</a>
                        {/* <p className="detail">(219) 772-1832</p> */}
                    </div>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Email</p>
                        <a className="detail" href="mailto:travelwiseindia@gmail.com">travelwiseindia@gmail.com</a>
                        {/* <a className="detail" href="mailto:supp.tour@example.com">supp.tour@example.com</a> */}
                    </div>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Address</p>
                        <p className="detail">No.1/52, Babu Rao Street,</p>
                        <p className="detail">(Near C.M.C Hospital),</p>
                        <p className="detail">Vellore - 632004. Tamil Nadu</p>
                    </div>
                </aside>

                <aside>
                    <figure>
                        <img src="../images/callWhite.svg" alt="call"/>
                    </figure>
                    <div>
                        <p className="title">Working Hours</p>
                        <p className="detail">Mon-Sat 10AM - 8PM </p>
                        <p className="detail">Sunday Holiday</p>
                    </div>
                </aside>
            </main>
            <main>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d36427.51090769812!2d79.11796140122937!3d12.923076013273025!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad39fd89a7e755%3A0xfc21029857dc8421!2sTravel%20wise!5e1!3m2!1sen!2sin!4v1737800094816!5m2!1sen!2sin" 
                    // width="600" 
                    // height="450" 
                    style={{width:"100%",height:"550px",border:0}}
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"/>
            </main>
        </section>
        <section className="wrapper container reach1Destination contact contactPage ">
            <figure>
                <img src="../images/about.webp" alt="Travel wise"/>
            </figure>
            <form className="form" onSubmit={onSubmit}>
                <p className="subTitle">Get In Touch</p>
                <h2 className="mainTitle">Explore The World, Expand Your Mind</h2>
                <div className="inputContainer">
                    <label>Name</label>
                    <input 
                        type="text"
                        name="name"
                        value={enqData.name}
                        onChange={onChangeInput}
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Mobile</label>
                    <input 
                        type="text"
                        name="mobile"
                        value={enqData.mobile}
                        onChange={onChangeInput}
                        required/>
                </div>
                <div className="inputContainer">
                    <label>Email</label>
                    <input 
                        type="email"
                        name="mail"
                        value={enqData.mail}
                        onChange={onChangeInput}
                        required/>
                </div>
                <div className="submitContainer">
                    <input type="submit" value={"Submit"}/>
                </div>
            </form>
        </section>
        </>
    )}